(function() {
'use strict';

angular
    .module('ekh')
    .controller('EmiratesHome', EmiratesHome);

function EmiratesHome(destinationService, cmsPageMapping) {
    const cm = this;
    cm.controls = { experiences: {} };

    cmsPageMapping.getHomePage().then(homepage => {
        const page = homepage[0];

        if (page) {
            destinationService.getTiles({ ControlId: page.controlid }).then(components => {
                const componentsByType = (_.groupBy(components, 'controltype'));
                _.forEach(componentsByType, component => {
                    component.forEach(c => {
                        destinationService.getTiles({ ControlId: c.controlid }).then(tiles => {
                            if (c.controltype === 'experiences') {
                                tiles.forEach(carousel => {
                                    destinationService.getTiles({ ControlId: carousel.controlid })
                                        .then(tiles =>
                                            cm.controls.experiences[carousel.controlid] = { title: carousel.name, tiles });
                                    cm.selectedTab = _.head(tiles).controlid;
                                });
                            } else {
                                cm.controls[c.controltype] = tiles;
                            }
                        });
                    });
                });
            }
            );
        }
    });
}
})();
